<template>
  <div v-if="state.open" class="dup-backdrop" @click.self="decide(false)">
    <div class="dup-modal" role="dialog" aria-modal="true" aria-labelledby="dup-title">
      <div class="form-card-header">
        <div class="section-number"><i class="fe fe-users" style="font-size: 12px;"></i></div>
        <div class="flex-grow-1">
          <h6 id="dup-title" class="mb-0 font-weight-bold text-white">This person may already be enrolled</h6>
          <small style="color: rgba(255,255,255,.75);">
            {{ person.firstname }} {{ person.lastname }}<span v-if="person.dob"> · born {{ person.dob }}</span> matches existing records
          </small>
        </div>
      </div>
      <div class="dup-body">
        <div v-for="m in state.matches" :key="m.type + m.id" class="dup-row">
          <div class="d-flex align-items-center flex-wrap" style="gap: 6px;">
            <span class="sev" :class="m.level === 'likely' ? 'sev-high' : 'sev-medium'">{{ m.level }}</span>
            <a :href="m.type === 'dependant' ? `/dependent/${m.id}` : `/client/${m.id}`" target="_blank" rel="noopener"><b>{{ m.name }}</b></a>
            <span class="small text-muted">{{ m.type === "dependant" ? `dependant of ${m.principal_name || "an enrollee"}` : "principal" }}</span>
          </div>
          <div class="small text-muted mt-1">
            <span v-if="m.id_card_number">ID {{ m.id_card_number }} · </span>
            <span v-if="m.dob">born {{ m.dob }} · </span>
            <span v-if="m.phone_number">phone {{ m.phone_number }} · </span>
            <span v-if="m.facility">{{ m.facility }} · </span>
            <span v-if="m.enrolled_at">enrolled {{ m.enrolled_at }}</span>
          </div>
          <div class="small mt-1"><i class="fe fe-info mr-1"></i>{{ m.reasons.join(", ") }}</div>
        </div>
      </div>
      <div class="dup-footer">
        <small class="text-muted mr-auto">Open a record to compare. Enrolling the same person twice creates two ID cards.</small>
        <button class="btn btn-outline-secondary" @click="decide(false)">Don't enrol</button>
        <button class="btn btn-danger" @click="decide(true)">Enrol anyway</button>
      </div>
    </div>
  </div>
</template>

<script>
import { duplicateState } from "@/service/duplicateGuard";

/** Shown by the duplicate guard (src/service/duplicateGuard.js) before an enrolment that may be a duplicate. */
export default {
  name: "DuplicateCheckModal",
  data() {
    return { state: duplicateState };
  },
  computed: {
    person() {
      return this.state.person || {};
    },
  },
  methods: {
    decide(proceed) {
      const resolve = this.state.resolve;
      Object.assign(this.state, { open: false, matches: [], person: null, resolve: null });
      if (resolve) resolve(proceed);
    },
  },
};
</script>

<style scoped>
@import "../reports.css";
.dup-backdrop { position: fixed; inset: 0; background: rgba(15, 23, 42, 0.55); z-index: 3000; display: flex; align-items: center; justify-content: center; padding: 16px; }
.dup-modal { background: #fff; border-radius: 14px; width: 100%; max-width: 640px; max-height: 90vh; display: flex; flex-direction: column; overflow: hidden; box-shadow: 0 20px 50px rgba(0,0,0,.25); }
.dup-body { padding: 12px 20px; overflow-y: auto; }
.dup-row { border: 1px solid #e2e8f0; border-radius: 10px; padding: 10px 12px; margin-bottom: 10px; }
.dup-footer { display: flex; align-items: center; gap: 8px; padding: 12px 20px; border-top: 1px solid #e2e8f0; flex-wrap: wrap; }
</style>
